import { useState } from "react";
import axios from "axios";
import DebouncedAutoComplete from "./DebouncedAutoComplete";

interface Props {
  value: string;
  onSelect: (e: React.SyntheticEvent<Element, Event>, option: string | null, reason: string) => void;
  size?: "small" | "medium";
  textboxMargin?: "dense" | "none" | "normal";
  disabled?: boolean;
  /** Override to drop the notched outline label (e.g. a floating pill on mobile). */
  textboxLabel?: string;
  textboxPlaceholder?: string;
}

const DebouncedOrderSearch = ({
  value,
  onSelect,
  size = "medium",
  textboxMargin = "none",
  disabled = false,
  textboxLabel = "Search by Order #",
  textboxPlaceholder = "Start typing..."
}: Props) => {
  const [options, setOptions] = useState<string[]>([]);
  const onInputChange = async (text: string, signal?: AbortSignal) => {
    if (!text) {
      setOptions([]);
      return;
    }
    const { data } = await axios.get(`/proxy/api/orders/FindRelatedOrdersByNumber?searchText=${text}`, {
      signal
    });
    setOptions(data || []);
  };

  return (
    <DebouncedAutoComplete
      autoHighlight
      disabled={disabled}
      value={value}
      options={options}
      size={size}
      getOptionsLabel={(option) => option || ""}
      onSelectedOptionChanged={onSelect}
      textboxMargin={textboxMargin}
      textboxLabel={textboxLabel}
      textboxPlaceholder={textboxPlaceholder}
      onDebouncedTextChanged={(text, signal) => onInputChange(text, signal)}
    />
  );
};

export default DebouncedOrderSearch;
